import { useState } from "react";
import styles from "./tenantofferaccept.module.css";
import Loader from "../../../components/Loader";
import { Helmet } from "react-helmet";
import { Background, Parallax } from 'react-parallax';
import { Link as Linkto, useHistory } from "react-router-dom";
import moment from 'moment';

const TenantOfferAccept = () => {
    const [loading, setLoading] = useState(false);

    return (<>
        {loading && <Loader />}
        <Helmet title="Offer" />
        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
            <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>
    
        <div className="WhiteBG">
            <div className={`${styles.RentalAppliArea}`}>
                <div className={`${styles.RentalAppliSuccessSec}`}>
                    <div className={`${styles.SuccessImgSec}`}>
                        <iframe className={`${styles.First}`} src="https://lottie.host/embed/20deca82-93ec-4d70-91e6-3492f2c74bdd/MwmlrwIIG0.lottie"></iframe>
                        <iframe className={`${styles.Second}`} src="https://lottie.host/embed/ec219002-a407-4240-acd9-752e4190d42b/WOu4vPkjrF.lottie"></iframe>
                    </div>
                    <p className={`${styles.PaymentSuccessTitle}`}>Congratulations!</p>
                    <p className={`${styles.PaymentSuccessTitleSub}`}>Thank you for accepting the offer. Your lease renewal link has been sent via SMS, or you can sign your lease using the button below.</p>
                    <button type="submit" className={`${styles.RentallAppliSubmitBU}`}>Renew Lease</button>
                </div>
            </div>
    
            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src='/static/img/logo.svg' alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: dev@fbc.nyc`}>dev@fbc.nyc</a></li>
                                <li><a href={`tel: (313) 777-8088`} >(313) 777-8088</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>2211 Pingree St <br />Detroit, MI 48206</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {moment().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </>)
}

export default TenantOfferAccept;